// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_settingBox__UeYdS{
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items:flex-start;
    position:absolute;
    top:68%;
    left:0 !important;
    position:absolute; 
    z-index:1000; 
    padding:10px;
    top:68%;
    right:unset !important;
    font-size: 11px;
}
.styles_settingBox__UeYdS>div>div{
    height:28px;
}
.styles_moreBoxRight__FcSdQ{
    right:0 !important;
    left:unset !important;

}
.styles_settingBoxRight__RbdrN{
    right:0px !important;
    left:unset !important;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UserMoreBox/styles.module.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,OAAO;IACP,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,oBAAoB;IACpB,qBAAqB;AACzB","sourcesContent":["\n.settingBox{\n    display:flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items:flex-start;\n    position:absolute;\n    top:68%;\n    left:0 !important;\n    position:absolute; \n    z-index:1000; \n    padding:10px;\n    top:68%;\n    right:unset !important;\n    font-size: 11px;\n}\n.settingBox>div>div{\n    height:28px;\n}\n.moreBoxRight{\n    right:0 !important;\n    left:unset !important;\n\n}\n.settingBoxRight{\n    right:0px !important;\n    left:unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingBox": `styles_settingBox__UeYdS`,
	"moreBoxRight": `styles_moreBoxRight__FcSdQ`,
	"settingBoxRight": `styles_settingBoxRight__RbdrN`
};
export default ___CSS_LOADER_EXPORT___;
